import React from "react";
import { gbp, pct } from "../lib/iht";

const Line = ({ label, value }) => (
  <div className="flex justify-between py-1.5 border-b border-black/20">
    <span>{label}</span>
    <span style={{ fontVariantNumeric: "tabular-nums" }} className="font-bold">{value}</span>
  </div>
);

const riskLabel = { low: "Low", medium: "Medium", high: "High" };

export const PrintReport = ({ r, v }) => (
  <div className="hidden print:block text-black" data-print-report>
    <h1 className="text-2xl font-bold">UK Inheritance Tax — Estimate</h1>
    <p className="text-sm mb-4">
      Simplified 2026/27 estimate. Generated {new Date().toLocaleDateString("en-GB")}. Not tax advice.
    </p>

    <div className="grid grid-cols-3 gap-4 mb-6">
      <div className="border-2 border-black p-3">
        <p className="text-xs uppercase">Estimated IHT due</p>
        <p className="text-xl font-bold">{gbp(r.ihtDue)}</p>
      </div>
      <div className="border-2 border-black p-3">
        <p className="text-xs uppercase">Effective rate</p>
        <p className="text-xl font-bold">{pct(r.effectiveRate)}</p>
      </div>
      <div className="border-2 border-black p-3">
        <p className="text-xs uppercase">Net to heirs</p>
        <p className="text-xl font-bold">{gbp(r.netToHeirs)}</p>
      </div>
    </div>

    <p className="mb-5 text-sm">
      Likelihood of Inheritance Tax: <span className="font-bold">{riskLabel[r.risk]}</span>. {r.summary}
    </p>

    <h2 className="text-lg font-bold mb-1">Figures entered</h2>
    <div className="text-sm mb-5">
      <Line label="Total estate value" value={gbp(v.estateValue)} />
      <Line label="Debts & funeral costs" value={gbp(v.debtsFuneral)} />
      <Line label="Home left to descendants" value={v.homeToDescendants ? "Yes" : "No"} />
      <Line label="Main home value" value={gbp(v.homeValue)} />
      <Line label="Unused NRB from spouse" value={`${Math.round(v.spouseNrbUnused * 100)}%`} />
      <Line label="Unused RNRB from spouse" value={`${Math.round(v.spouseRnrbUnused * 100)}%`} />
      <Line label="Charity legacy" value={gbp(v.charityLegacy)} />
      <Line label="Gifts in last 7 years" value={gbp(v.gifts7y)} />
      <Line label="Years since gifts" value={`${v.giftYears} yr(s)`} />
    </div>

    <h2 className="text-lg font-bold mb-1">Breakdown</h2>
    <div className="text-sm mb-5">
      <Line label="Net estate" value={gbp(r.netEstate)} />
      <Line label="Nil-rate band used" value={gbp(r.nrb)} />
      <Line label="Residence nil-rate band" value={gbp(r.rnrb)} />
      <Line label="Charity legacy" value={gbp(r.charity)} />
      <Line label="Chargeable gifts" value={gbp(r.giftsChargeable)} />
      <Line label="Applied tax rate" value={pct(r.rate)} />
    </div>

    <p className="text-xs">
      For general information only — not tax advice. Estimates use simplified 2026/27 thresholds
      (NRB £325,000, RNRB up to £175,000, 40%/36% rates, £2m taper). For complex situations or
      planning, consult a qualified adviser. Source: gov.uk/inheritance-tax
    </p>
  </div>
);
